import { connect } from 'react-redux'
import ExamplesEntry from './examples-entry'
import { getExample } from '../../../../../../stores/examples/examples.selectors'
import { format } from 'date-fns'
import { copyExample } from '../../../../../../stores/examples/examples.actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, history }) => {
  const example = getExample(state, id)
  return {
    id: example.id,
    fileId: id,
    title: example.title,
    createdAt: format(example.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${example.id}`,
    //conclusion: example.concluded,
    //student: example.student_type && example.student_type.account.full_name,
    judgement: example.judgement,
    premium: example.premium,
    thumb:
      example.works &&
      example.works[0] &&
      example.works[0].media &&
      example.works[0].media[0] &&
      example.works[0].media[0].thumb_url,
    author: example.teacher_type && example.teacher_type.full_name,
    ageGroupTitle:
      example.student_types &&
      example.student_types[0] &&
      example.student_types[0].year_group &&
      example.student_types[0].year_group.title,
    ageGroupOrder:
      example.student_types &&
      example.student_types[0] &&
      example.student_types[0].year_group &&
      example.student_types[0].year_group.order
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () => {
    return dispatch(copyExample(ownProps.id)).then(() =>
      ownProps.history.push('/my-files')
    )
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ExamplesEntry)
)
